import { IShape2d } from '@/editor/types/shape';
import { LineSeg2d } from '../LineSeg2d';
import { Point2dUtils } from '../Point2dUtils';
import { IPoint2d } from '../IPoint2d';
import { ArcSeg2d } from '../arcSeg2d';
import { normalizeAngle } from '../utils';

function sortLineSegPointsIndexes(points: IPoint2d[], lineSeg: LineSeg2d) {
  const segStartPoint = lineSeg.start;
  const indexes = new Array(points.length).fill(0).map((_, index) => index);

  indexes.sort((a, b) => {
    const d1 = Point2dUtils.distanceTo(points[a], segStartPoint);
    const d2 = Point2dUtils.distanceTo(points[b], segStartPoint);
    return d1 - d2;
  });
  return indexes;
}

function sortArcSegPointsIndexes(points: IPoint2d[], arcSeg: ArcSeg2d) {
  const { center, startAngle, clockwise } = arcSeg;
  const angles = points.map((point) => {
    const angle = normalizeAngle(Math.atan2(point.y - center.y, point.x - center.x));
    return clockwise ? normalizeAngle(startAngle - angle) : normalizeAngle(angle - startAngle);
  });

  return new Array(points.length)
    .fill(0)
    .map((_, index) => index)
    .sort((a, b) => {
      return angles[a] - angles[b];
    });
}

export function sortPointsIndexes(points: IPoint2d[], shape: IShape2d): number[] {
  if (shape instanceof LineSeg2d) {
    return sortLineSegPointsIndexes(points, shape);
  }
  if (shape instanceof ArcSeg2d) {
    return sortArcSegPointsIndexes(points, shape);
  }

  // 其他待实现
  return new Array(points.length).fill(0).map((_, index) => index);
}
